import apiClient from '@u/apiClient'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  fetchThirdPartyCostInvoiceItem(_ctx, { id, invoice_id }) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`invoicing/${invoice_id}/invoice-item/${id}`)
        .then((response) => {
          resolve(response.data.invoice_item)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchAllThirdPartyCost({ commit }, payload = {}) {
    const { filters = [], page = 1 } = payload
    return new Promise((resolve, reject) => {
      apiClient
        .get(`third_party_cost`, {
          params: {
            filters,
            paginate: 50,
            page
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchPaidInvoiceItemsByThirdPartyCostId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/third-party-cost-payment/${payload.thirdPartyCostId}/paid-invoice-items`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewThirdPartyPayment: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise(async (resolve, reject) => {
      apiClient
        .get(`model/new?model=thirdPartyCostPayment`)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  fetchPaymentById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`invoicing/${payload.invoice_id}/payment/${payload.payment_id}`)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  fetchInvoiceChiftPayments: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`invoicing/${payload.invoice_id}/chift-payments`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchInvoicePaymentSyncHistory: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`invoicing/${payload.invoice_id}/payment-sync-history`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchPaymentsByInvoicingId: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`invoicing/${payload.invoice_id}/payment`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  linkPaymentToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`invoicing/${payload.invoice_id}/link-payment`, {
          payment_id: payload.payment_id
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // region store
  storeNewThirdPartyCostPayment: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise(async (resolve, reject) => {
      let url = `third-party-cost-payment`
      apiClient
        .post(url, payload)
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateThirdPartyCostPaymentById: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      let url = `third-party-cost-payment/${payload.id}`
      apiClient
        .put(url, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  deletePayment: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`invoicing/${payload.invoice_id}/payment/${payload.payment_id}`)
        .then((response) => {
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  unlinkPayment: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `invoicing/${payload.invoice_id}/payment/${payload.payment_id}/unlink`,
          {
            deletion_type: payload.deletion_type
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async undoDeletePayment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(
          `invoicing/${payload.invoice_id}/payment/${payload.payment_id}/undo-delete`
        )
        .then((response) => {
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
